/**
 * Report-Definition für die Liste der offenen Punkte.
 *
 * Übersetzt den geladenen Datenstand in ein {@link ReportDocument}. Analog zu
 * {@link ./projektauftragReport}: deklariert nur den Inhalt, der gemeinsame
 * Renderer erzeugt das PDF.
 */
import {
  buildDocument,
  tableBlock,
  type ReportBlock,
  type ReportDocument,
} from '../../../lib/pdf/reportModel';

export interface OffenePunkteReportItem {
  titel: string | null;
  kategorie: string | null;
  status: string;
  verantwortlich: string | null;
  faellig: string | null;
}

export interface OffenePunkteReportInput {
  items: OffenePunkteReportItem[];
}

/** 'YYYY-MM-DD' -> 'DD.MM.YYYY'; leere/ungültige Werte -> ''. */
function formatDate(iso: string | null): string {
  if (!iso) return '';
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso);
  return m ? `${m[3]}.${m[2]}.${m[1]}` : iso;
}

export function buildOffenePunkteReport(input: OffenePunkteReportInput): ReportDocument {
  const block: ReportBlock =
    input.items.length > 0
      ? tableBlock(
          [
            { header: 'Titel', weight: 2.6 },
            { header: 'Kategorie', weight: 1.5 },
            { header: 'Status', weight: 1.4 },
            { header: 'Verantwortlich', weight: 1.8 },
            { header: 'Fällig', weight: 1.2 },
          ],
          input.items.map((op) => [
            op.titel || '—',
            op.kategorie || '—',
            op.status || '—',
            op.verantwortlich || '—',
            formatDate(op.faellig) || '—',
          ]),
        )!
      : { kind: 'note', value: 'Noch keine offenen Punkte erfasst.' };

  return buildDocument([{ title: 'Offene Punkte', blocks: [block] }]);
}
